import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { WithChildrenProps } from '@app/types/generalTypes';
import { saveReturnTo } from '@app/smart-audit/auth/returnTo';

const RequireAuth: React.FC<WithChildrenProps> = ({ children }) => {
  // const token = useAppSelector((state) => state.user.user);
  const token = localStorage.getItem('refreshToken');
  const location = useLocation();

  if (!token) saveReturnTo(location.pathname + location.search + location.hash);

  return token ? <>{children}</> : <Navigate to="/auth/login" replace />;
};

export default RequireAuth;
